<div class="content" id="content" *ngIf="userProfile">

    <div class="banner" [style.background-image]="'url(' + userProfile?.backgroundImgUrl + ')'">
        <!-- <img class="banner" [src]="userProfile?.backgroundImgUrl" alt=""> -->
        <span class="change-cover-tag" style="cursor: pointer;z-index: 1;" (click)="hiddenBackgroundfileinput.click()"
            *ngIf="!publicView">Change Cover</span>
        <div class=" user-icon-container">
            <div style="position: relative; padding: 0; cursor: pointer;">
                <img class="founding-pat-icon"
                    src="https://creatics-profile-frames.s3-us-west-1.amazonaws.com/FoundingPatron.png" alt=""
                    *ngIf="userProfile?.isFounder">
                <img class="img-circle user-icon" [src]="userProfile?.profilePic" *ngIf="userProfile?.profilePic">
                <img src="../../../assets/images/user-icon-1.png" alt="" class="user-icon"
                    *ngIf="!userProfile.profilePic">
                <span style="position: absolute;color: #3E2723;
              font-size: 16px;
              font-weight: 700; " class="span-content" (click)="openUploadProfileImage()" *ngIf="!publicView">Change
                    Image</span>
            </div>
        </div>

    </div>
    <div class="welcome-text" [ngClass]="(userProfile.isFounder) ? 'align_founder': 'welcome-text'">
        <span>Hi I'm</span>
        <span style="color: #fa4616;">&nbsp;{{userProfile?.firstName}} {{userProfile?.lastName}}</span>

    </div>
    <div class="welcome-sub-text" *ngIf="userProfile?.updateMyWords?.length > 0">
        <span>{{userProfile?.updateMyWords}}</span>
    </div>
    <div class="welcome-rank-text">
        <div *ngIf="userProfile" style="width: 215px;margin-top: 5px;">RANK : {{rank}} <img
                [src]="rankUrl" alt="" style="width:16%;font-size: 20px;"></div>
        <div class="chat-title" (click)="showChatPopup()" *ngIf="differentUser"> <img
                src="../../../../assets/images/chatprofile.png" alt="" class="chat-icon"></div>
        <div class="seeTresurey" (click)="scroll(target)">
            {{" See My Treasury" | uppercase}}</div>
    </div>
    <div class="awards-container">
            <div class="videoDiv12" *ngIf="publicView">
                <div>
                    <video controls class="video1" #pubVidPlayer preload="metadata" (ended)="videoEndedForPublic()"
                    src={{userProfile.imVideoUrl}} loop muted>
                </video>
                <span class="videoMessage" *ngIf="!userProfile?.imVideoUrl">No Content Available</span>

                </div>
              <div>
                <span  *ngIf="userProfile?.imVideoUrl && differentUser" style="cursor: pointer;" class="upvoteBtn">
                    <span style="display: flex;align-items: center;" *ngIf="!isIAMVideoUpvoted"   (click)="postIAMVideoUpvote()" ><img style="max-width: 30px;" src="../../../../assets/images/diamond.png"> &nbsp; <b class="upvote-title">Jewel I am Video</b></span>
                    <span style="display: flex;align-items: center;" *ngIf="isIAMVideoUpvoted"><img style="max-width: 30px;" src="../../../../assets/images/jewel-unselected.png">&nbsp;  <b class="upvote-title">You have already Jeweled this I am Video</b></span>
                </span>
              </div>
                <!-- <div *ngIf="userProfile?.imVideoUrl && !hidePlayBtnVid" class="videoMessage"><img
                        src="assets/images/play.png" alt="" (click)="playVideoForPublic()"></div> -->

            </div>

            <div class="upload-iam-container videoDiv" *ngIf="!publicView">
                <video controls id="video1" *ngIf="userProfile?.imVideoUrl" #privateVidPlayer preload="metadata"
                    (ended)="videoEndedVid1()">
                    <source [src]="userProfile?.imVideoUrl" loop muted>
                </video>
                <div *ngIf="userProfile?.imVideoUrl" class="videoEdit"><img title="Edit"
                        src="assets/images/icons-orange.png" alt="" (click)="editIamVideo()"></div>

                <div *ngIf="userProfile?.imVideoUrl == null" class="iam-video-icon">
                    <img (click)="redirectToIAM()" src="assets/svg/photo icon.svg" alt="">
                </div>
                <div *ngIf="userProfile?.imVideoUrl == null" (click)="redirectToIAM()" style="margin-top: 5px;"
                    class="btn-iam">Upload IAM video
                </div>
            </div>
            <div class="awards-container-block">
                <div class="desktop-view">
                    <div class="award-header" style="margin-top: 5px;">I'm a creator of:
                    </div>
                    <div style="display: flex;flex-wrap: wrap;" *ngIf="userProfile?.creatorOf?.length;">
                        <ng-container *ngFor="let item of userProfile.creatorOf;let i=index">
                            <div class="comming-soon-btn" style="background: #4FC4D5;" *ngIf="i <=2">
                                <ng-container>
                                    {{item.name ? item.name : 'Coming Soon' }}
                                </ng-container>
                            </div>
                        </ng-container>

                    </div>
                    <div style="display: flex;flex-wrap: wrap;" *ngIf="!userProfile?.creatorOf?.length">
                        <div class="comming-soon-btn">Coming Soon
                        </div>
                    </div>
                    <div class="award-header" style="margin-top: 5px;">I'm a fan of:
                    </div>
                    <div style="display: flex;flex-wrap: wrap;" *ngIf="userProfile?.fanOf?.length;">
                        <ng-container *ngFor="let item of userProfile.fanOf;let i=index">
                            <div class="comming-soon-btn" *ngIf="i <=2">
                                <ng-container>
                                    {{item.name ? item.name : 'Coming Soon' }}
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>
                    <div style="display: flex;flex-wrap: wrap;" *ngIf="!userProfile?.fanOf?.length">
                        <div class="comming-soon-btn">Coming Soon
                        </div>
                    </div>

                    <div class="award-header" style="margin-bottom: 5px;">Awards & Badges</div>
                    <div>
                        <ng-image-slider [images]="imageObject" #nav
                            [imageSize]="{width: '125px', height: '125px', space: 4}"
                            [imagePopup]="false"></ng-image-slider>

                    </div>
                    <div style="margin-top: 8px;"></div>
                </div>
                <div class="mob-view">
                    <div class="award-header" style="margin-top: 5px;">I'm a creator of:
                    </div>
                    <div style="display: flex;flex-wrap: wrap;justify-content: center;"
                        *ngIf="userProfile?.creatorOf?.length;">
                        <ng-container *ngFor="let item of userProfile.creatorOf;let i=index">
                            <div class="comming-soon-btn" style="background: #4FC4D5;" *ngIf="i <=2">
                                <ng-container>
                                    {{item.name ? getName(item.name) : 'Coming Soon' }}
                                </ng-container>
                            </div>
                        </ng-container>

                    </div>
                    <div style="display: flex;flex-wrap: wrap;" *ngIf="!userProfile?.creatorOf?.length">
                        <div class="comming-soon-btn">Coming Soon
                        </div>
                    </div>
                    <div class="award-header" style="margin-top: 5px;">I'm a fan of:
                    </div>
                    <div style="display: flex;flex-wrap: wrap;justify-content: center;" *ngIf="userProfile?.fanOf?.length;">
                        <ng-container *ngFor="let item of userProfile.fanOf;let i=index">
                            <div class="comming-soon-btn" *ngIf="i <=2">
                                <ng-container>
                                    {{item.name ? getName(item.name) : 'Coming Soon' }}
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>
                    <div style="display: flex;flex-wrap: wrap;" *ngIf="!userProfile?.fanOf?.length">
                        <div class="comming-soon-btn">Coming Soon
                        </div>
                    </div>

                    <div class="award-header" style="margin-bottom: 5px;">Awards & Badges</div>
                    <div>
                        <ng-image-slider [images]="imageObject" #nav
                            [imageSize]="{width: '125px', height: '125px', space: 4}"
                            [imagePopup]="false"></ng-image-slider>

                    </div>
                </div>
            </div>

    </div>
    <div>

    </div>
    <div class="welcome-header-text" id="treasury_sec">
        <div>My Treasury </div>
        <div class="public-btn" (click)="toggleView()" *ngIf="!differentUser">{{publicView? 'Private View' : 'Public
            View'}}</div>
    </div>
    <div class="treasury-content " id="tresures" #target>
        <div class="card" style="width: 20rem;max-height: 300px;" *ngIf="!publicView">
            <img src="../../../assets/icons/add.svg" class="card-img-top" alt="..." (click)="openAddNewDialog($event)"
                style="width: 25%;">
        </div>
        <div class="card" style=" max-height: 160px;font-size: 20px;font-weight: 600;" *ngIf="publicView && !getTresuries()">
            Coming Soon
        </div>
        <ng-container *ngIf="!publicView">
            <div class="card" style="width: 20rem;cursor: pointer" *ngFor="let item of userProfile?.treasuries"
                (click)="selectedTresures=item;openDialogForViewTresures()">
                <div class="card-img-top"
                    [ngStyle]="{'background': 'linear-gradient(180deg, rgba(0, 0, 0, 0) 51.9%, #000000 100%), url('+ item?.treasuryImageUrl +')', 'width': '100%', 'height': '100%','background-size':'cover'}">
                </div>


                <div class="option-icons" *ngIf="!publicView">
                    <div><img src="../../../assets/images/edit.png" alt="" title="Edit"
                            (click)="selectedTresures=item;openDialog($event)">
                    </div>
                    <div *ngIf="!item.hidden"><img src="../../../assets/images/hidden.png" alt="" title="Hide"
                            (click)="hideTresuresConfirmation($event,item)"></div>
                    <div *ngIf="item.hidden"><img src="../../../assets/images/show.png" alt="" title="Un-Hide"
                            (click)="hideTresuresConfirmation($event,item)"></div>
                    <div><img src="../../../assets/images/delete.png" alt="" title="Delete"
                            (click)="deleteTresuresConfirmation($event,item)"></div>
                </div>
                <div class="overlay">

                </div>
                <div class="overlay overlay_1">
                    <div>
                        <h3 [title]="item?.treasuryTitle" class="treasuryTitle-name" style="cursor: pointer;">
                            {{item?.treasuryTitle | titlecase}}
                        </h3>
                    </div>
                    <div [title]="item?.treasuryName" class="sub-name" style="cursor: pointer;">{{item?.treasuryName |
                        titlecase}}</div>
                </div>

            </div>
        </ng-container>
        <ng-container *ngIf="publicView">
            <ng-container *ngIf="userProfile?.treasuries.length">
                <ng-container *ngFor="let item of userProfile?.treasuries">
                    <div class="card" style="width: 20rem;cursor: pointer"   *ngIf="!item.hidden">
                        <div class="card-img-top" (click)="selectedTresures=item;openDialogForViewTresures()"
                            [ngStyle]="{'background': 'linear-gradient(180deg, rgba(0, 0, 0, 0) 51.9%, #000000 100%), url('+ item?.treasuryImageUrl +')', 'width': '100%', 'height': '100%','background-size':'cover'}">
                        </div>

                        <div class="option-icons" *ngIf="!publicView">
                            <div><img src="../../../assets/images/edit.png" alt="" title="Edit"
                                    (click)="selectedTresures=item;openDialog($event)">
                            </div>
                            <div *ngIf="!item.hidden"><img src="../../../assets/images/hidden.png" alt="" title="Hide"
                                    (click)="hideTresuresConfirmation($event, item)"></div>
                            <div *ngIf="item.hidden"><img src="../../../assets/images/show.png" alt="" title="Un-Hide"
                                    (click)="hideTresuresConfirmation($event, item)"></div>
                            <div><img src="../../../assets/images/delete.png" alt="" title="Delete"
                                    (click)="deleteTresuresConfirmation($event, item)"></div>
                        </div>
                        <div class="overlay">

                        </div>
                        <div class="overlay overlay_1">
                            <div>
                                <h3 [title]="item?.treasuryTitle" class="treasuryTitle-name"
                                    (click)="selectedTresures=item;openDialogForViewTresures()" style="cursor:pointer">
                                    {{item?.treasuryTitle |
                                    titlecase}}
                                </h3>
                            </div>
                            <div [title]="item?.treasuryName" class="sub-name">{{item?.treasuryName | titlecase}}</div>
                        </div>

                    </div>
                </ng-container>
            </ng-container>
            <ng-container *ngIf="!userProfile?.treasuries.length">
                <div class="card" style="width: 20rem;max-height: 300px;" *ngIf="!publicView">

                </div>
            </ng-container>

        </ng-container>
    </div>
</div>

<!-- <input style="display: none" type="file" accept="image/*" (change)="onFileSelectProfile($event)"
    #hiddenProfilefileinput> -->
<input style="display: none" type="file" accept="image/*" (change)="onFileSelectBackground($event)"
    #hiddenBackgroundfileinput>


<ng-template #viewDialog>
    <h2 matDialogTitle class="popup-title">{{selectedTresures.treasuryTitle}}</h2>
    <mat-dialog-content id="treasuryModal">
        <div style="display: flex;justify-content:center;flex-direction:column;align-items:center;cursor:pointer" *ngIf="differentUser">
       <span *ngIf="selectedTresures.upvoted === 'true'"  (click)="postUpvote()" style="font-size: 36px;"><img style="max-width:30px" src="../../../../assets/images/jewel-unselected.png"></span>
       <span  *ngIf="selectedTresures.upvoted === 'false'" (click)="postUpvote()" style="font-size: 36px;"><img style="max-width:30px" src="../../../../assets/images/diamond.png"></span>
            <span>Jewel</span>
            </div>
        <p style="margin-top: 5px;font-size:16px">Experience this treasure via this <a
                (click)="goToLink(selectedTresures.treasuryExpThis)" style="color:blue; cursor:pointer">link</a>. Come
            back to this Creatics page easily by
            clicking
            on its browser tab.</p>
            <p class="desc-dialog"> {{selectedTresures.treasuryDesc}}</p>

        <div style="display: flex;justify-content:center;align-items:center">
            <img [src]="selectedTresures?.treasuryImageUrl" alt="" id="imgForTreasury">

        </div>


    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button matDialogClose color="primary">Dismiss</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #deleteDialog let-data>
    <h2 matDialogTitle>Confirmation</h2>
    <mat-dialog-content>
        <h2>
            <p><b>Are you sure you want to delete this Treasure?</b></p>
        </h2>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button matDialogClose color="primary">No</button>
        <button cdkFocusInitial class="btn btn-primary save-treasury-btn universal-button-gradient" type="submit"
            (click)="deleteTresures(data)">Yes</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #hideDialog let-data>
    <h2 matDialogTitle>Confirmation</h2>
    <mat-dialog-content>
        <h2>
            <p><b>Are you sure you want to {{data.hidden ? 'hide' : 'un-hide'}} this Treasure?</b></p>
        </h2>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button matDialogClose color="primary">No</button>
        <button cdkFocusInitial class="btn btn-primary save-treasury-btn universal-button-gradient" type="submit"
            (click)="hideTresures(data)">Yes</button>
    </mat-dialog-actions>
</ng-template>

<ng-template #uploadImageDialog let-data>
    <h2 matDialogTitle>Upload Profile Image</h2>
    <mat-dialog-content>
        <div class="imgUpload" [ngClass]="imageBoxDisable ? 'imgUpload' : 'uncheckedClass'"
            (click)="image1.click();click()" accept=".jpg, .jpeg,.png">
            <div>

                <image-cropper *ngIf="stopCropper" [imageChangedEvent]="imgChangeEvt" [maintainAspectRatio]="true"
                    [aspectRatio]="4 / 4" [resizeToWidth]="256" format="png"
                    (imageCropped)="imageCropped($event,'image')" (imageLoaded)="imgLoad()"
                    (cropperReady)="initCropper()" (loadImageFailed)="imgFailed()">
                </image-cropper>

                <figure class="icons" input type="file" accept="image/*">

                    <input class="form-control" type="file" [disabled]="imageFlag" (change)="onFileChange($event)"
                        accept="image/*" #image1>
                    <div class="items-center">
                        <img src="assets\svg\photo icon.svg" *ngIf="iconDisabled" height="50">
                    </div>
                    <figcaption class="vdocaption" style="color:black" *ngIf="iconDisabled">
                        Upload Profile Picture
                    </figcaption>
                    <img *ngIf="!stopCropper" [src]="cropImgPreview">


                </figure>
            </div>

        </div>
        <button class="cropButton" *ngIf="cropButton"
            [ngStyle]="(clickedCrop) ? {'visibility': 'hidden'} : {'visibility': 'visible'} "
            (click)="cropImage('image1')"> CROP
        </button>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button matDialogClose color="primary">Dismiss</button>
        <button [disabled]="!clickedCropBtn" cdkFocusInitial
            class="btn btn-primary save-treasury-btn universal-button-gradient" type="submit"
            (click)="onFileSelectProfile()">Save</button>
    </mat-dialog-actions>
</ng-template>


<ng-template #progressDialog>
    <mat-dialog-content>
        <p style="font-size: 18px;">Processing.. please wait!</p>
    </mat-dialog-content>
    <mat-spinner [diameter]="30" [strokeWidth]="3" mode="indeterminate" style="margin: auto;"></mat-spinner>
    <!-- <mat-dialog-actions align="end">
          <button mat-button matDialogClose color="primary">Dismiss</button>
        </mat-dialog-actions> -->
</ng-template>
<div #talkjsContainer></div>